export const colors = {
  primaryMain: '#007c66',
  textPrimary: '#1e233e'
};
